import { SET_WAITER_CALLS_NOTIFICATIONS, SET_WAITER_CALLS_WAITERS } from '../../actionTypes/waiterCalls'

export const setWaiterCallsWaiters = value => ({ type: SET_WAITER_CALLS_WAITERS, value })

export const setWaiterCallsNotifications = value => ({ type: SET_WAITER_CALLS_NOTIFICATIONS, value })
